import { useState } from 'react';
import { LORE_OPENING } from '@tb/shared';

import { Dialog, Icon } from '../ui/kit';

// ---------------------------------------------------------------------------
// The optional story (docs/world/LORE.md), opened from "Read the story".
// Every passage can be skipped; nothing moves on by itself.
// ---------------------------------------------------------------------------

export function LoreOpening({ close, onTrain }: { close: () => void; onTrain?: () => void }) {
  const [page, setPage] = useState(0);
  const last = page === LORE_OPENING.length - 1;
  const done = close;
  return <Dialog size="lg" material="housing" className="lore-opening" onClose={done} aria-label="Trading Blows: the story" data-testid="lore-opening"
    actions={<>
      <span className="lore-count" aria-hidden="true">{page + 1} / {LORE_OPENING.length}</span>
      {!(last && onTrain) && <button className="btn sm ghost" onClick={done} data-testid="lore-skip">Skip</button>}
      {last && onTrain && <button className="btn" onClick={onTrain} data-testid="lore-train">Begin training</button>}
      <button className="btn primary" autoFocus onClick={() => (last ? done() : setPage(page + 1))} data-testid="lore-next">
        {last ? 'Take command' : 'Continue'} <Icon name="arrow-right" />
      </button>
    </>}>
    <div className="lore-passage" key={page} aria-live="polite">
      {LORE_OPENING[page].map((line, i) => <p key={i} style={{ animationDelay: `${i * 0.35}s` }}>{line}</p>)}
    </div>
  </Dialog>;
}
